import StaticLanguagePage from '../StaticLanguagePage';
import englishPageData from './englishPageData';

export default function EnglishStaticPage() {
  return <StaticLanguagePage language={englishPageData} />;
}
